import AddProtectedEnvironmentsSelect from './AddProtectedEnvironmentsSelect';

export default AddProtectedEnvironmentsSelect;
export * from './AddProtectedEnvironmentsSelect';
